import qs from 'query-string';
import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MainDashboardLayoutComponent } from 'components/main-layout/main.component';
import { ButtonSubmit } from 'components/button/button-submit.component';
import { TableSearchInputComponent } from 'components/table/table-search.component';
import { TableButtonExport } from 'components/table/table-button-export.component';
import { TableButtonLimitComponent } from 'components/table/table-button-limit.component';
import { TableButtonSortComponent } from 'components/table/table-button-sort.component';
import { BasicTableComponent } from 'components/table/table-basic.component';
import { Pagination } from 'components/table/table-pagination.component';
import { EmptyStateComponent } from 'components/empty-data';
import { BounceLoading } from 'components/loader/bounce.loading';
import { ModalTableSortComponent } from 'components/modal/modal-table-sort.component';
import { ModalTableLimitComponent } from 'components/modal/modal-table-limit.component';
import { ModalConfirmation } from 'components/modal/moda.confirmation.component';
import { setToolsReducer } from 'reducers/tools.reducer';
import { useStoreList } from 'api/store/store-list/store-list.query.api';
import { useDeleteStore, useExportStoreList } from 'api/store/store-list/store-list.mutation.api';
import { StandartImageComponent } from 'components/image/standart-image.component';
import { toast } from 'react-toastify';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Tooltip } from 'flowbite-react';
import { PATH_CONSTANT } from 'config/path.constant';
import { catchErrorMessage } from 'ui-utils/string.utils';
import { HighlightedText } from 'components/highlighted-text';

const BREAD_CUMB_ITEMS = [
  {
    title: 'Store',
    path: PATH_CONSTANT.STORE.STORE_LIST,
  },
  {
    title: 'Store List',
    path: PATH_CONSTANT.STORE.STORE_LIST,
  },
];

const SORT_OPTIONS = [
  { label: 'Urutkan Nama A-Z', sortType: 'asc', sortBy: 'name' },
  { label: 'Urutkan Nama Z-A', sortType: 'desc', sortBy: 'name' },
  { label: 'Tanggal Buat Terbaru - Terdahulu', sortType: 'desc', sortBy: 'created_at' },
  { label: 'Tanggal Buat Terdahulu - Terbaru', sortType: 'asc', sortBy: 'created_at' },
];

export const StoreListComponent = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const INITIAL_VALUE_FILTER_QUERY = {
    limit: searchParams.get('limit')?.replace(/[^0-9]/g, '') || 20,
    page: searchParams.get('page')?.replace(/[^0-9]/g, '') || 1,
    orderBy: searchParams.get('orderBy')?.replace(/[^a-zA-Z_]/g, '') || 'created_at',
    orderType: searchParams.get('orderType')?.replace(/[^a-zA-Z_]/g, '') || 'desc',
    search: searchParams.get('search')?.replace(/[^a-zA-Z0-9 ]/g, '') || undefined,
  };
  const [queryFilter, setQueryFilter] = useState(INITIAL_VALUE_FILTER_QUERY);

  const { selectedRowKeys: selectedIds } = useSelector((state) => state.tools);

  const [modals, setModals] = useState({
    sort: false,
    limit: false,
    export: false,
    delete: false,
  });
  const [modalDeleteData, setModalDeleteData] = useState({ storeId: null, storeName: null });

  const { mutate: exportStore, isLoading: isExporting } = useExportStoreList();
  const { mutate: deleteStoreById, isLoading: isDeleting } = useDeleteStore();

  const {
    data: storeList,
    isLoading,
    isError,
    error,
  } = useStoreList({
    filter: queryFilter,
  });

  const columns = useMemo(
    () => [
      {
        type: 'checkbox',
        isRightBorderAvailable: true,
        render: (record) => {
          return (
            <div className='form-check px-2'>
              <input
                className='form-check-input appearance-none h-4 w-4 border border-green rounded-sm bg-white checked:bg-green checked:border-green focus:outline-none transition duration-200 align-top bg-no-repeat bg-center bg-contain float-left cursor-pointer'
                type='checkbox'
                readOnly
              />
            </div>
          );
        },
      },

      {
        name: 'Nama Store',
        className: 'w-[25%] text-sm font-semibold text-green text-center',
        dataIndex: 'name',
        render: (record) => (
          <div class='w-[25%] text-sm font-semibold text-green '>
            <div class='flex items-center'>
              <div class='w-12'>
                <StandartImageComponent
                  src={record?.image || '/img/default-store.jpg'}
                  class='w-10 h-10 rounded-sm overflow-hidden object-cover object-center'
                />
              </div>
              <div class='w-9/12 pl-3 xl:pl-5'>
                <div class='overflow-hidden block text-ellipsis whitespace-normal line-clamp-3 text-sm font-semibold text-dark hover:text-green mb-1'>
                  <Tooltip className='max-w-[30%]' content={record?.name}>
                    <HighlightedText text={record?.name} highlight={queryFilter?.search} />
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        ),
      },
      {
        name: 'Alamat Store',
        className: 'w-[40%] text-sm font-semibold text-green',
        dataIndex: 'address',
        render: (record) => (
          <div class='w-[40%] pr-10'>
            <div class='text-sm text-gray line-clamp-4'>
              <Tooltip className='max-w-[40%]' content={record?.address}>
                <HighlightedText text={record?.address} highlight={queryFilter?.search} />
              </Tooltip>
            </div>
          </div>
        ),
      },
      {
        name: 'Lokasi Store',
        className: 'w-[18%] text-sm font-semibold text-green',
        dataIndex: 'location',
        render: (record) => (
          <div class='w-[18%]'>
            <div class='text-sm text-gray'>
              <HighlightedText text={record?.city?.name} highlight={queryFilter?.search} />
            </div>
          </div>
        ),
      },
      {
        name: 'Action',
        className: 'w-[15%] text-sm font-semibold text-green text-center',
        dataIndex: '',
        render: (record) => (
          <div className='w-[15%]'>
            <ul class='flex items-center justify-center action'>
              <li class='flex items-center'>
                <Link to={`${PATH_CONSTANT.STORE.STORE_EDIT}/${record.id}`}>
                  <span class='icon-ico-pencil-edit text-yellow text-xl'></span>
                </Link>
              </li>
              <li class='flex items-center'>
                <button
                  onClick={() => {
                    setModalDeleteData({ storeId: record.id, storeName: record.name });
                    setModals({ ...modals, delete: true });
                  }}
                  type='button'
                >
                  <span class='icon-ico-delete text-red-1 text-xl'></span>
                </button>
              </li>
            </ul>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queryFilter?.search]
  );

  const resetCheckList = () => {
    if (selectedIds.length > 0) {
      dispatch(setToolsReducer({ selectedRowKeys: [], selectedRows: [] }));
    }
  };

  const handleExport = () => {
    exportStore(
      {
        queryFilter: queryFilter,
        bodyFilter: { store_ids: selectedIds },
      },
      {
        onSuccess: (res) => {
          const link = document.createElement('a');
          link.href = res.data.download_url;
          document.body.appendChild(link);
          link.click();
          setModals({ ...modals, export: false });
        },
      }
    );
  };

  const handleOnDeleteStore = () => {
    deleteStoreById(
      { storeId: modalDeleteData.storeId },
      {
        onSuccess: () => {
          setModals({ ...modals, delete: false });
          toast.success(`Store ${modalDeleteData.storeName} berhasil dihapus!`);
        },
      }
    );
  };

  useEffect(() => {
    resetCheckList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeList]);

  return (
    <MainDashboardLayoutComponent breadCumbs={BREAD_CUMB_ITEMS}>
      <div className='flex items-center mb-5'>
        <div className='w-[calc(100%-340px)] flex items-center justify-between'>
          <TableSearchInputComponent
            initialValue={INITIAL_VALUE_FILTER_QUERY.search}
            inputProps={{
              disabled: isLoading,
            }}
            placeholder='Cari nama store...'
            onSearch={(value) => {
              setQueryFilter({ ...queryFilter, search: value.keyword, page: 1 });
              navigate({
                search: qs.stringify({
                  ...queryFilter,
                  search: value.keyword || undefined,
                  page: 1,
                }),
              });
            }}
          />

          <div className='xl:w-[calc(100%-45%)] lg:w-[calc(100%-48%)] md:w-[calc(100%-42%)] flex xl:justify-start lg:justify-between md:justify-between items-center'>
            <TableButtonSortComponent
              disabled={isLoading}
              onClick={() => {
                setModals((prev) => ({ ...prev, sort: true }));
              }}
            />

            <TableButtonLimitComponent
              disabled={isLoading}
              value={queryFilter.limit}
              onClick={() => setModals({ ...modals, limit: true })}
            />
            <TableButtonExport
              disabled={isLoading}
              loading={isExporting}
              onClick={() => {
                setModals({ ...modals, export: true });
              }}
            />
          </div>
        </div>
        <div className='w-[340px] flex items-center justify-end'>
          <div className='w-[215px]'>
            <ButtonSubmit
              disabled={isLoading}
              onClick={() => navigate('/store/create')}
              className='bg-green w-full flex items-center justify-center hover:bg-dark-green transition duration-75 ease-in-out rounded-sm text-white py-2 font-semibold text-sm px-7'
            >
              <span class='icon-ico-plus-circle text-[20px] leading-[21px] mr-3'></span>
              Create Store
            </ButtonSubmit>
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className='h-[70vh] flex items-center'>
          <BounceLoading color='#5E755A' />
        </div>
      ) : (
        <>
          <div className='italic text-dark text-sm mb-5'>{`Total ${storeList?.data?.total_result} stores`}</div>

          <BasicTableComponent
            rowClassName='flex items-center rounded-sm py-4 px-2 border border-solid border-transparent hover:border-green bg-white hover:bg-light-green transition duration-75 ease-in-out cursor-pointer'
            columns={columns}
            dataSource={storeList?.data?.rows || []}
            loading={isLoading}
            error={isError}
            errorTitle={`${error?.response?.data?.status} - ${error?.response?.data?.code}`}
            errorMessage={catchErrorMessage(error?.response?.data?.message)}
          />

          {storeList?.data?.total_result === 0 && (
            <EmptyStateComponent
              message={queryFilter.search ? `No result for query "${queryFilter.search}"` : 'No data available'}
            />
          )}

          <Pagination
            currentPage={queryFilter.page}
            pageSize={queryFilter.limit}
            siblingCount={1}
            totalCount={storeList?.data?.total_result || 0}
            onPageChange={(page) => {
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              setQueryFilter({ ...queryFilter, page });
              navigate({
                search: qs.stringify({
                  ...queryFilter,
                  page,
                }),
              });
            }}
          />
        </>
      )}
      <ModalTableSortComponent
        options={SORT_OPTIONS}
        initialValue={SORT_OPTIONS.find(
          (sortItem) => sortItem.sortBy === queryFilter.orderBy && sortItem.sortType === queryFilter.orderType
        )}
        onChange={({ selected }) => {
          setQueryFilter((prevState) => ({
            ...prevState,
            orderBy: selected.sortBy,
            orderType: selected.sortType,
          }));
          navigate({
            search: qs.stringify({
              ...queryFilter,
              orderBy: selected.sortBy,
              orderType: selected.sortType,
            }),
          });
          setModals({ ...modals, sort: false });
        }}
        visible={modals.sort}
        onClose={() => setModals({ ...modals, sort: false })}
      />

      <ModalTableLimitComponent
        onChange={({ limit }) => {
          setQueryFilter((prevState) => ({
            ...prevState,
            limit,
            page: 1,
          }));
          navigate({
            search: qs.stringify({
              ...queryFilter,
              limit,
              page: 1,
            }),
          });
          setModals({ ...modals, limit: false });
        }}
        initialValue={queryFilter.limit}
        visible={modals.limit}
        onClose={() => setModals({ ...modals, limit: false })}
      />
      <ModalConfirmation
        description='Apakah anda yakin ingin eksport data yang anda pilih ?'
        title='Export Data'
        visible={modals.export}
        onConfirm={handleExport}
        onClose={() => setModals({ ...modals, export: false })}
      />
      <ModalConfirmation
        description={`Apakah anda yakin ingin menghapus store (${modalDeleteData.storeName}) ini?`}
        title='Delete Data'
        imageIcon='/img/Delete.png'
        textConfirm='Delete'
        loading={isDeleting}
        visible={modals.delete}
        onConfirm={handleOnDeleteStore}
        onClose={() => setModals({ ...modals, delete: false })}
      />
    </MainDashboardLayoutComponent>
  );
};
